module.exports = __webpack_public_path__ + "media/images/banner/klook/pc/rental-o_770_280_zh-hant-4b755fc57bb2a8f1c78752146cf22300.jpg";